(() => {
  const DELIVERY_ID = 'beurredor-delivery-box';
  const PAYMENT_ID = 'beurredor-payment-box';
  let scheduled = false;

  const deliveryHtml = `
    <div id="${DELIVERY_ID}" class="beurredor-delivery-box" role="note" aria-label="Informations de livraison">
      <div class="beurredor-delivery-row">
        <span class="beurredor-delivery-icon" aria-hidden="true">🚚</span>
        <span><strong>PACA :</strong> livraison en 24 h</span>
      </div>
      <div class="beurredor-delivery-row">
        <span class="beurredor-delivery-icon" aria-hidden="true">❄️</span>
        <span><strong>France :</strong> livraison réfrigérée Chronofresh sous 24 à 48 h ouvrées</span>
      </div>
      <div class="beurredor-delivery-row">
        <span class="beurredor-delivery-icon" aria-hidden="true">📍</span>
        <span>Frais de livraison calculés automatiquement selon votre adresse avant le paiement.</span>
      </div>
    </div>`;

  const paymentHtml = `
    <div id="${PAYMENT_ID}" class="beurredor-payment-box" role="note" aria-label="Moyens de paiement">
      <div class="beurredor-payment-title"><span aria-hidden="true">🔒</span> Paiement sécurisé</div>
      <ul class="beurredor-payment-list">
        <li class="beurredor-payment-item"><span class="beurredor-payment-icon" aria-hidden="true">💳</span><span>Carte bancaire</span></li>
        <li class="beurredor-payment-item"><span class="beurredor-payment-icon" aria-hidden="true">P</span><span>PayPal</span></li>
        <li class="beurredor-payment-item"><span class="beurredor-payment-icon" aria-hidden="true">🏦</span><span>Virement bancaire</span></li>
        <li class="beurredor-payment-item"><span class="beurredor-payment-icon" aria-hidden="true">📅</span><span>Paiement à 30 jours<span class="beurredor-payment-note">Après validation du compte professionnel</span></span></li>
        <li class="beurredor-payment-item"><span class="beurredor-payment-icon" aria-hidden="true">🚚</span><span>Paiement à la livraison en PACA<span class="beurredor-payment-note">Selon accord</span></span></li>
      </ul>
      <p class="beurredor-security-note">Les moyens disponibles sont confirmés lors du passage en caisse.</p>
    </div>`;

  function createFromHtml(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  }

  function applyEnhancements() {
    const details = document.querySelector('.product-details');
    const buyBlock = details?.querySelector('.buy-buttons-block') || document.querySelector('main .buy-buttons-block');
    if (!buyBlock) return;

    buyBlock.classList.add('beurredor-product-buy-buttons');
    const formComponent = buyBlock.querySelector('product-form-component');
    if (!formComponent) return;

    if (!buyBlock.querySelector(`#${DELIVERY_ID}`)) {
      buyBlock.insertBefore(createFromHtml(deliveryHtml), formComponent);
    }

    if (!buyBlock.querySelector(`#${PAYMENT_ID}`)) {
      formComponent.insertAdjacentElement('afterend', createFromHtml(paymentHtml));
    }

    buyBlock
      .querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button, .shopify-payment-button__more-options')
      .forEach((element) => {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      });
  }

  function scheduleEnhancements() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyEnhancements();
    });
  }

  function start() {
    applyEnhancements();
    const observer = new MutationObserver(scheduleEnhancements);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleEnhancements);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
